import type { ApiResponseBody } from "@/lib/api/api-type-helper";
import { apiClient } from "@/lib/api/client";
import { getDataOrThrowApiError } from "@/lib/api/error";

type StoreHeaderResponse = ApiResponseBody<
  "/v2/marketplace/store/header",
  "get"
>;

/**
 * ストアヘッダーを取得するAPI関数
 */
export async function fetchStoreHeader(): Promise<StoreHeaderResponse> {
  const res = await apiClient.GET("/v2/marketplace/store/header");

  return getDataOrThrowApiError(res);
}
